import { observer } from 'mobx-react-lite';
import * as React from 'react';

const styles = require('./HeaderFooterMessage.scss');

export interface HeaderFooterMessageProps {
    message: string;
}

export const HeaderFooterMessage = observer(function HeaderFooterMessage(
    props: HeaderFooterMessageProps
) {
    const { message } = props;
    return (
        <div className={styles.headerFooterContainer} title={message}>
            {message}
        </div>
    );
});
